module.exports = __webpack_public_path__ + "media/images/reg_1_redesign_marital_status-027a3c97.png";